<template>
	<div class="button-slot">
		<a :href="urlProp" :class="'button--' + colourProp" class="button button--primary">{{ labelProp }}</a>
	</div> <!-- product__col -->
</template>

<script>

export default {
	props: ['urlProp', 'labelProp', 'colourProp'],
	data() {
		return {};	
	},
};
</script>

<style scoped>
	.button-slot {
		display: inline-block;
		margin: 0;
	}

	@media screen and (min-width: 470px) {
		.button-slot {
			width: auto;
		}
	}
</style>
